import * as moment from 'moment';
import { pluralize } from 'journalize';

let today = moment().format('YYYY-MM-DD');

// change these if the dates change
// the format moments of the date must match the format you tell moment
let registrationDeadline = moment('2020-10-5', 'YYYY-MM-DD'),
  mailStateDeadline = moment('2020-10-23', 'YYYY-MM-DD'),
  earlyVotingFirstDay = moment('2020-10-13', 'YYYY-MM-DD'),
  earlyVotingLastDay = moment('2020-10-30', 'YYYY-MM-DD'),
  texasGeneral = moment('2020-11-03', 'YYYY-MM-DD');

// we add one day because the day of each deadline also counts
let registrationDiff = registrationDeadline.diff(today, 'days'),
  mailStateDiff = mailStateDeadline.diff(today, 'days'),
  earlyVotingDiff = earlyVotingFirstDay.diff(today, 'days'),
  earlyVotingLastDayDiff = earlyVotingLastDay.diff(today, 'days'),
  texasGeneralDiff = texasGeneral.diff(today, 'days');

// select days containers
let registrationSlot = document.querySelector('#registration-slot'),
  mailStateSlot = document.querySelector('#mail-state-slot'),
  earlyVotingSlot = document.querySelector('#early-voting-slot'),
  texasGeneralSlot = document.querySelector('#texas-general-slot');

// select notes containers
let registrationNote = document.querySelector('#registration-note'),
  mailStateNote = document.querySelector('#mail-state-note'),
  mailStateSubtext = document.querySelector('#mail-state-subtext'),
  earlyVotingNote = document.querySelector('#early-voting-note'),
  earlyVotingSubtext = document.querySelector('#early-voting-subtext'),
  texasGeneralNote = document.querySelector('#texas-general-note');

// select date containers
let registrationDate = document.querySelector('#registration-date'),
  mailStateDate = document.querySelector('#mail-state-date'),
  earlyVotingDate = document.querySelector('#early-voting-date'),
  texasGeneralDate = document.querySelector('#texas-general-date');

// if the deadlines have passed, set the text content to 0 days
if (registrationDiff < 0) {
  registrationSlot.className += ' display-none';
  registrationNote.textContent = 'was the last day to register to vote';
  registrationNote.className += ' date-passed';
  registrationDate.className += ' date-passed';
} else if (registrationDiff == 1) {
  registrationSlot.textContent = 'Tomorrow';
  registrationNote.textContent = 'is the last day to register to vote';
} else if (registrationDiff == 0) {
  registrationSlot.textContent = 'Today';
  registrationNote.textContent = 'is the last day to register to vote';
} else {
  registrationSlot.textContent = `${registrationDiff} day${pluralize(
    registrationDiff
  )} left`;
}

// if (mailStateDiff < 4) {
//   mailStateSubtext.textContent = 'USPS deadline was Oct. 19';
// } else if (mailStateDiff == 4) {
//   mailStateSubtext.textContent = 'USPS deadline is today';
// }

if (mailStateDiff < 0) {
  mailStateSlot.className += ' display-none';
  mailStateNote.textContent =
    'was the last day for counties to receive mail-in ballot requests';
  mailStateNote.className += ' date-passed';
  mailStateDate.className += ' date-passed';
} else if (mailStateDiff == 1) {
  mailStateSlot.textContent = 'Tomorrow';
  mailStateNote.textContent =
    'is the last day for counties to receive mail-in ballot requests';
} else if (mailStateDiff == 0) {
  mailStateSlot.textContent = 'Today';
  mailStateNote.textContent =
    'is the last day for counties to receive mail-in ballot requests';
} else {
  mailStateSlot.textContent = `${mailStateDiff} day${pluralize(
    mailStateDiff
  )} left`;
}

if (earlyVotingDiff < 0) {
  earlyVotingDate.textContent = 'Oct. 30';
  earlyVotingNote.textContent = 'until early voting ends';
  earlyVotingSubtext.className += ' display-none';

  if (earlyVotingLastDayDiff < 0) {
    earlyVotingSlot.className += ' display-none';
    earlyVotingNote.textContent = 'was the last day of early voting';
    earlyVotingNote.className += ' date-passed';
    earlyVotingDate.className += ' date-passed';
  } else if (earlyVotingLastDayDiff == 1) {
    earlyVotingSlot.textContent = 'Tomorrow';
    earlyVotingNote.textContent = 'is the last day of early voting';
  } else if (earlyVotingLastDayDiff == 0) {
    earlyVotingSlot.textContent = 'Today';
    earlyVotingNote.textContent = 'is the last day of early voting';
  } else {
    earlyVotingSlot.textContent = `${earlyVotingLastDayDiff} day${pluralize(
      earlyVotingLastDayDiff
    )} left`;
  }
} else if (earlyVotingDiff == 1) {
  earlyVotingSlot.textContent = 'Tomorrow';
  earlyVotingNote.textContent = 'is the first day of early voting';
} else if (earlyVotingDiff == 0) {
  earlyVotingSlot.textContent = 'Today';
  earlyVotingNote.textContent = 'is the first day of early voting';
} else {
  earlyVotingSlot.textContent = `${earlyVotingDiff} day${pluralize(
    earlyVotingDiff
  )} left`;
}

if (texasGeneralDiff < 0) {
  texasGeneralSlot.className += ' display-none';
  texasGeneralNote.textContent = 'was Election Day';
  texasGeneralNote.className += ' date-passed';
  texasGeneralDate.className += ' date-passed';
} else if (texasGeneralDiff == 1) {
  texasGeneralSlot.textContent = 'Tomorrow';
  texasGeneralNote.textContent = 'is the Texas general';
} else if (texasGeneralDiff == 0) {
  texasGeneralSlot.textContent = 'Today';
  texasGeneralNote.textContent = 'is the Texas general';
} else {
  texasGeneralSlot.textContent = `${texasGeneralDiff} day${pluralize(
    texasGeneralDiff
  )} left`;
}
